import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import './app/ajs/module.ajs';
import './app/ajs/router.ajs';
import './app/ajs/index'; // Modules

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// import ajsApp from './app/ajs/module.ajs';
// import states from './app/ajs/router.ajs';
// states(ajsApp);
